<template>
    <div>
        <image-component :infoType="'banner'" :infoKey="`fatherBanner`"></image-component>
        <div class="content">
            <div class="intro_tab" @click="changeTab('vision')" :class="{'active': tab === 'vision'}">비전</div>
            <div class="intro_tab" @click="changeTab('business')" :class="{'active': tab === 'business'}">주요사업</div>
            <div class="intro_tab" @click="changeTab('info')" :class="{'active': tab === 'info'}">발자취</div>
            <div class="intro_tab" @click="changeTab('financial')" :class="{'active': tab === 'financial'}">재무보고</div>

        </div>


        <image-component v-if="tab === 'vision'" :infoType="'file'" :infoKey="`vision`"></image-component>
        <board-list-component v-else-if="tab === 'business'" :boardType="'business'"></board-list-component>
        <board-list-component v-else-if="tab === 'financial'" :boardType="'financial'"></board-list-component>
        <div v-else-if="tab === 'info'" class="content">
<!--            <terms-component :termsType="`info`"></terms-component>-->
            <history-component></history-component>
        </div>
        <div v-else-if="tab === 'support'">
            <div class="content" >
                <button class="down_btn" @click="downloadFile()">정기후원 신청서</button>
                <button class="down_btn" @click="openUrl()">일시후원</button>
            </div>
        <image-component  :infoType="'file'" :infoKey="`support`"></image-component>
        </div>


    </div>
</template>

<script>
    // @ is an alias to /src

    import ImageComponent from "@/components/information/ImageComponent";
    import BoardListComponent from "@/components/board/BoardListComponent";
    import TermsComponent from "@/components/terms/TermsComponent";
    import {runFileDown} from "@/mixins/fileApiDown"
    import HistoryComponent from "@/components/history/HistoryComponent";

    export default {
        name: 'Intro',
        mixins: [],
        components: {TermsComponent, BoardListComponent, ImageComponent, HistoryComponent},
        props: {},
        data() {
            return {
                tab: 'vision'
            }
        },
        beforeRouteEnter(to, from, next) {
            let checkTab = from.query.hasOwnProperty('tab')
            next(vm => {
                if (checkTab) {
                    vm.tab = from.query.tab
                }
            })
        },
        created() {
            let checkTab = this.$route.query.hasOwnProperty('tab')
            if (checkTab) {
                this.changeTab(this.$route.query.tab)
            }
        },
        mounted() {

        },
        beforeDestroy() {
        },
        destroyed() {
        },
        computed: {},
        methods: {
            changeTab(tab) {
                this.$router.replace(this.$route.path);
                this.tab = '';
                this.$nextTick(() => {
                    this.tab = tab
                })

            },
            downloadFile(){
                let params = {
                    a_container_type:'supportDownload',
                    a_container_id :1
                }
                runFileDown(params)
            },
            openUrl() {
                let openNewWindow = window.open("about:blank");
                openNewWindow.location.href = "https://mrmweb.hsit.co.kr/v2/Member/SupportOnce.aspx?action=once&server=p1sI9yjs7eXe0DMIKf7SCA==&supportgroup=171";
            }
        },
        watch: {
            '$route.fullPath': {
                deep: true,
                handler: function () {
                this.$route.query.hasOwnProperty('tab') ?this.changeTab(this.$route.query.tab) :''
            }
        },
        },
    }
</script>
<style lang="scss">
    .intro_tab {
        color: #9f9f9f;
        width: 25%;
        border-top: 1px solid;
        border-bottom: 1px solid;
        display: inline-block;
        text-align: center;
    }

    .intro_tab:first-child {
        border-left: 1px solid;
    }

    .intro_tab:last-child {
        border-right: 1px solid;
    }
</style>
